import { loanActionApi, loanActionApiV2 } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_ACTIONS_ACTION_TYPE = createNamedActions(`loanActionsExecution`, {
  GET_LOAN_ACTIONS: 'GET_LOAN_ACTIONS',
});

export const getLoanActionsForLoanAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanActionApiV2.getLoanActionsByApplicationId(params);

  return dispatch({
    type: LOAN_ACTIONS_ACTION_TYPE.GET_LOAN_ACTIONS,
    payload: data,
  });
});

export const getLoanActionsHistory = catchAsyncActionError(params => async () => {
  const { data } = await loanActionApi.getLoanActionsHistory(params);

  return { payload: data };
});
